import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import HeaderComponent from '../HeaderComponent';

import Table from '../table/Table';
import TableRow from '../../containers/table/TableRow';


class FrontComponent extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        tickers: PropTypes.array.isRequired,
        link: PropTypes.string.isRequired,
        breakpoint: PropTypes.string,
    };

    render() {
        const { t } = this.props;

        let tableHeadings;
        if (this.props.breakpoint === 'mobile-small') {
            tableHeadings = ['', '', t('common:last'), t('common:percentChange')];
        } else {
            tableHeadings = [
                '',
                '',
                t('common:last'),
                t('common:change'),
                t('common:percentChange'),
            ];
        }

        return (
            <HeaderComponent title={t(this.props.title)} link={this.props.link}>
                <Table headings={ tableHeadings }>
                    {this.props.tickers.map(ticker => (
                        <TableRow
                            {...ticker}
                            key={ticker.symbol}
                            breakpoint={this.props.breakpoint === 'mobile-small'}
                        />
                    ))}
                </Table>
            </HeaderComponent>
        );
    }
}

export default translate('menu')(FrontComponent);



/** WEBPACK FOOTER **
 ** /src/shared/components/front/FrontComponent.js
 **/